import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-payments-approve',
  templateUrl: './payments-approve.component.html',
  styleUrls: ['./payments-approve.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule]
})
export class PaymentsApproveComponent implements OnInit {

  public pay: string;
  public error: string;
  public message: string;

  constructor(
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.pay = this.activatedRoute.snapshot.queryParams.pay;
    this.error = this.activatedRoute.snapshot.queryParams.error;
    this.getErrorMessage();

  }
  public getErrorMessage() {
    if (this.error === 'INVALID_REQUEST') {
      this.message = 'Lo sentimos, ha ocurrido un error al procesar tu método de pago. Por favor verifica que la información ingresada sea correcta';
    } else {
      this.message = 'Lo sentimos, ha ocurrido un error al procesar tu método de pago. Por favor contáctanos para resolverlo';
    }
  }
}

